<template>
  <div>
    <div v-if="navs.length > 0" class="nav">
      <label @click="goNav(-1)" class="active">首页</label>
      <label :class="{ active: idx < navs.length - 1 }" @click="goNav(idx)" v-for="(nav, idx) in navs" :key="nav.n">
        > {{ nav.n }}</label>

      <span class="desc">
        <v-icon :size="16" color="orange">info</v-icon>可点击左边<b>蓝色连接</b>可以返回
      </span>
    </div>
    <mo-org-chart @bar_click="onBarClick" @org_stu_click="onOrgStuClick" @org_clazz_click="onOrgClazzClick"
      v-show="navs.length == 0" />
    <component @bar_click="onBarClick" @org_stu_click="onOrgStuClick" @org_clazz_click="onOrgClazzClick"
      v-for="(nav, idx) in navs" :key="nav.n" :is="nav.comp" :loc="nav.loc" v-show="idx == navs.length - 1"
      :cfg="nav.cfg" />
  </div>
</template>
<script>
import MoOrgChart from "./mo-org-chart.vue";
import { Crud } from "javaee-fre";

const ClazzRuleView = () => import("./clazzrule-view.vue");

export default {
  name: "mo-org-dash",
  components: {
    "mo-org-chart": MoOrgChart,
    crud: Crud,
  },
  data() {
    return { navs: [] };
  },
  methods: {
    onClazzRuleView(rid) {
      let self = this,
        navs = self.navs;
      navs.push({
        n: "培训内容",
        comp: ClazzRuleView,
        cfg: { targetId: rid },
      });
    },
    onOrgClazzClick(o) {
      let self = this,
        navs = self.navs;
      navs.push({
        n: o.name + "培训计划",
        comp: Crud,
        cfg: {
          url: "/home/my/mo/clazz",
          params: { _oid: o.id },
          refreshable: false,
          countEndding: "个培训计划",
          listItemActions: [
            {
              label: "查看培训内容",
              icon: "details",
              func(cfg) {
                self.onClazzRuleView(cfg.item.ruleId);
              },
            },
          ],
        },
      });
    },
    onOrgStuClick(o) {
      let self = this,
        navs = self.navs;
      function onIdnoClick(n, v, row) {
        if (n != 'idno' || !v) return;
        let self = this;
        self.$axios.get(`/home/my/mo/stu/decrypt/${row.id}/idno`).then(r => {
          if (r.data.status == 'ok') {
            let m = r.data.message;
            self.$dialog.info(`<ul><li>身份证：${m.idno}</li><li>年龄：${m.age} </li><li>性别：${m.gender == 'M' ? '男' : '女'}</li></ul>`);
            return;
          }
          self.$status(r.data.message || '获取不到完整身份证');
        });
      }

      navs.push({
        n: o.name + "学员",
        comp: Crud,
        cfg: {
          url: "/home/my/mo/stu",
          params: { _oid: o.id },
          refreshable: false,
          countEndding: "名学员",
          listItemFilter(i, acts) {
            if (i.exceptionFlag) {
              i._rowClazz = "exception-flag";
            }
            if (i.idno) {
              i.idno = { name: i.idno, _icon: 'visibility', _iconAct: onIdnoClick };
            }
            return acts;
          },
          listItemActions: [
            {
              label: "培训记录",
              icon: "timeline",
              func(cfg) {
                navs.push({
                  n: `学员${cfg.item.name}的培训记录`,
                  comp: Crud,
                  cfg: {
                    url: "/home/my/mo/stuclazz",
                    params: { _aid: cfg.item.id },
                    refreshable: false,
                  },
                });
              },
            },
            {
              label: "人脸采集",
              icon: "face",
              func(cfg) {
                navs.push({
                  n: `学员${cfg.item.name}的人脸采集`,
                  comp: Crud,
                  cfg: {
                    url: "/home/my/mo/stuface",
                    params: { _aid: cfg.item.id },
                    refreshable: false,
                    listItemFilter(i, acts) {
                      i.img = {
                        _component: {
                          name: "crud-list-avatar-item",
                          cfg: {
                            url: `${self.$const.baseUrl}/home/my/mo/stuface/img/${i.tenantId}/${i.orgId}/${i.clazzId}/${i.accountId}/${i.id}/${i.img}?s=100x100`,
                            previewUrl: `${self.$const.baseUrl}/home/my/mo/stuface/img/${i.tenantId}/${i.orgId}/${i.clazzId}/${i.accountId}/${i.id}/${i.img}`,
                          },
                        },
                      };
                      return acts;
                    },
                  },
                });
              },
            }
          ],
        },
      });
    },
    goNav(idx) {
      let self = this,
        navs = self.navs;
      idx += 1;
      navs.splice(idx, navs.length - idx);
    },
    onBarClick(r) {
      let self = this,
        navs = self.navs;
      navs.push({ n: r.n, comp: MoOrgChart, loc: r.id });
    },
    init() { },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.nav {
  padding-bottom: 16px;
  font-size: 10px;
  color: #9e9e9e;
}

.nav label.active {
  cursor: pointer;
  color: #0068b7;
}

.nav .desc {
  float: right;
  color: orange;
}
</style>